/**
 * Shared constants for the Question Banks surfaces.
 *
 * Extracted verbatim from QuestionBanksPage.jsx during the Phase 5 refactor
 * (no behaviour change).
 */
export const NEXT_STATUS = {
  draft:     ['in_review', 'retired'],
  in_review: ['approved', 'draft', 'retired'],
  approved:  ['published', 'draft', 'retired'],
  published: ['retired', 'draft'],
  retired:   [],
};

// Banks-purple is the page accent. Lifecycle pill colours layered over it:
// draft → neutral (incomplete), in_review → amber (eyes needed), approved →
// blue (sign-off pending publish), published → banks-purple (in production),
// retired → muted strikethrough (archived).
export const STATUS_PILL_CLS = {
  draft:     'bg-muted text-muted-foreground border-border',
  in_review: 'bg-amber-500/15 text-amber-700 dark:text-amber-300 border-amber-500/30',
  approved:  'bg-blue-500/15 text-blue-700 dark:text-blue-300 border-blue-500/30',
  published: 'bg-[var(--lumyn-banks)]/15 text-[var(--lumyn-banks)] border-[var(--lumyn-banks)]/40',
  retired:   'bg-muted/60 text-muted-foreground/70 border-border line-through',
};

export const SORT_OPTIONS = [
  { value: 'recent',     label: 'Recently updated' },
  { value: 'title_asc',  label: 'Title (A → Z)' },
  { value: 'most_items', label: 'Most items' },
  { value: 'least_pub',  label: 'Least published' },
];

export const ALL_STATUSES = ['draft', 'in_review', 'approved', 'published', 'retired'];
